<template>
  <!-- <a v-if="item.href" :href="item.href"> -->
  <div class="product">
    <a
      v-if="item.href"
      :href="getCategoryTranslation(item.href)"
      style="color: #0c0c0c;"
    >
      <div class="card" :class="item.product_type" @click="dataLayer(item)">
        <div class="item">
          <div class="bg-white machine" style="border-radius: 6px">
            <div class="content row mx-0">
              <div
                class="col-5 product-img"
                v-bind:style="{
                  backgroundImage: 'url(' + item.img + ')',
                }"
              ></div>
              <div class="col-7">
                <p class="discontinued mb-3" v-if="item.notinuse">
                  <img src="@/assets/images/discontinued-color-icon.svg" />
                  {{ $getTranslation("DISCONTINUED", $route.params.region)}}
                </p>
                <p v-else class="product-type">
                  {{
                    item.product_type_label === "Machine"
                      ? "Device"
                      : $getTranslation(item.product_type_label, $route.params.region)
                  }}
                </p>
                <h3 class="heading-xs">{{ item.title }}</h3>
                <!-- <ul>
                  <li v-for="description in item.descriptions">
                    {{ description }}
                  </li>
                </ul> -->
                <a
                  v-if="item.href"
                  class="btn cta-plain text-red icon right-arrow"
                  >{{ $getTranslation("Find out more", $route.params.region) }}</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </a>
  </div>
  <!-- </a> -->
</template>

<script>
export default {
  props: ["item"],
  methods: {
    dataLayer(data) {
      const fileClicked = {
        event: "product_click",
        product_name: data.title,
        clickURL: data.href,
        pagePath: window.location.href,
      };

      window.dataLayer.push(fileClicked);
    },
    getCategoryTranslation(url) {
      let categoryName = "";

      if (!url.includes("http")) {
        const [, , categoryTitle] = url.split("/");
        categoryName = categoryTitle;
      } else {
        const [, , , , categoryTitle] = url.split("/");
        categoryName = categoryTitle;
      }

      const newUrl = url.replace(categoryName, this.$getCategoryTranslation(categoryName, this.$route.params.region));
      return newUrl;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../css/abstracts/path";
@import "../../../../css/abstracts/colors";
@import "../../../../css/base/typography";

.product {
  width: 100%;
  height: 100%;
  padding: 0.75rem;

  .card {
    position: relative;
    background-color: $cc-resmed-white;
    border-radius: 6px;
    box-shadow: -1px 0.25rem 0.75rem 0.125rem rgba(164 164 164 / 12%);
    height: 100%;

    .product-type {
      position: relative;
      margin-bottom: 0.75rem;
      text-transform: capitalize;
      font-family: "Plus Jakarta Sans", Arial, sans-serif;
      font-size: 14px;
      color: #9e9e9e;
    }
  }

  .content {
    padding: 1.2rem;
    display: flex;
    height: 100%;

    h3 {
      margin-bottom: 1rem;
      min-height: 56px;
      font-size: 1.175rem;
    }

    ul {
      list-style: none;
      margin-bottom: 2rem;

      li {
        // @extend %body-small;

        > span {
          margin-right: 0.25rem;
        }
      }
    }

    .btn {
      margin-top: auto;
      align-self: flex-start;
    }
  }

  .cta-plain.text-red.right-arrow {
    background-size: 0.63rem 0.63rem;
    background-repeat: no-repeat;
    background-image: url(/img/icon-right-arrow-red.a072f6d8.svg);
    position: absolute;
    bottom: 0;
  }

  .cta-plain.text-red {
    color: #0D0A15;
  }
}

.discontinued {
  border: 2px solid #0D0A15;
  color: #0D0A15;
  padding: 2px 9px;
  border-radius: 50px;
  font-size: 10px;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  width: fit-content;
}
</style>
